import React, { useEffect } from "react";
import "./SurveyResponse.css"; // Import CSS file
import { useLocation, useNavigate } from "react-router-dom";
import CheckIcon from "../../../assets/CheckIcon.svg"; // Import the SVG
import { useTranslation } from "react-i18next";
import moment from "moment";


const usePreventBack = () => {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const onPopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);
}

export default function SurveyResponse() {
  usePreventBack();
  const location = useLocation();
  const { title, endDate, backgroundImage } = location.state || {};
  const { t } = useTranslation();
  const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey");
  const navigate = useNavigate();

  const handleCancel = () => {
    if (isExternalUserSurvey !== 'true') {
      navigate("/user/survey");
    }
  }

  useEffect(() => {
    if (isExternalUserSurvey === 'true') {
      sessionStorage.setItem("isSurveyResponseSubmitted", true);
      sessionStorage.setItem("surveyResponseData", JSON.stringify({ title: title, endDate: endDate }));
    }
    sessionStorage.setItem("isExternalUserQuestionsPageOpen", false);
    const event = new Event('sessionStorageUpdated');
    window.dispatchEvent(event);

    sessionStorage.setItem("isUserSurveysQuePageOpen", 'false');
    const event1 = new Event('sessionStorageUpdated1');
    window.dispatchEvent(event1);
  }, [])

  return (
    <div className="survey-survey-response-container1">
      <div className="row center-xs middle-xs" style={{ minHeight: "80vh" }}>
        <div className="col-xs-12">
          <div className="row center-xs">
            <div className="col-xs-12 col-md-8" style={{ textAlign: "center" }}>
              <h2>{title}</h2>
              {/* <p>
                <Moment format="DD MMM YYYY">
                  {new Date()}
                </Moment>
              </p> */}
            </div>
          </div>
          <div className="row center-xs">
            <div className="col-xs-12">
              <img
                src={CheckIcon}
                alt="Success"
                className="tick-icon"
                style={{ width: 40, height: 40 }}
              />
            </div>
          </div>
          <div className="row center-xs">
            <div className="col-xs-12">
                <p className="survey-submission-text1">
                  <b>{t("thankYou")}</b> <br />
                  <span>  {t("surveySubmittedOn", { date: moment(new Date()).format("DD MMM YYYY") })}</span>
                </p>
                {isExternalUserSurvey === 'true'
                  ? <span>{t("pleaseCloseWindow")}</span>
                  : <button className="cancelButton" onClick={handleCancel}>
                      {t("close")}
                    </button>
                }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}